import React, { useRef, useEffect, useState } from "react";

export default function Paypal({ gotoLastStep }) {
  const paypal = useRef();

  useEffect(() => {
    window.paypal
      .Buttons({
        createOrder: (data, actions, err) => {
          return actions.order.create({
            intent: "CAPTURE",
            locale: "ES",
            purchase_units: [
              {
                description: "Cool looking table",
                amount: {
                  currency_code: "MXN",
                  value: 650.0,
                },
              },
            ],
          });
        },
        onApprove: async (data, actions) => {
          const order = await actions.order.capture();
          if (order.status === "COMPLETED") {
            gotoLastStep();
          }
        },
        onError: (err) => {
          console.log(err);
        },
      })
      .render(paypal.current);
  }, []);

  return (
    <div>
      <div style={{ width: "300px", margin: "0 auto" }} ref={paypal}></div>
    </div>
  );
}
